/**
 * @param {*} comments
 * @param {number} commentId
 * @returns {*}
 */
export const removeCommentFromComments = (comments, commentId) =>
  comments.filter((comment) => comment.id !== commentId);
